import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34c22a70&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=34c22a70&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=34c22a70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.96.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c22a70",
  null
  
)

export default component.exports